import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { useIntl } from 'react-intl'
import clsx from 'clsx'
import { useField } from 'formik'
import { Box, Button } from '@material-ui/core'
import { useSocialMediaSetting } from './useSocialMediaSetting'
import MediaContainer from './MediaContainer'
import { isNil } from 'ramda'
import { ErrorIcon } from 'app/components/icons'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  root: {
    '&.MuiPaper-root': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      border: 'solid 1px',
      boxShadow: 'none',
    },
    '& .MuiAppBar-root': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
    '& .MuiCardContent-root': {
      paddingBottom: '16px !important',
      overflowX: 'scroll !important',
      overflowY: 'hidden !important',
    },
    '& .MuiCircularProgress-colorPrimary': {
      color: theme.palette.disable.default,
    },
  },
  inputImage: {
    width: '70px',
    height: '70px',
  },
  image: {
    width: '70px',
    height: '70px',
  },
  borderGrey: {
    borderColor: 'rgb(153,153,153)',
  },
  borderGreen: {
    borderColor: 'rgb(79,217,117)',
  },
  iconDeleted: {
    right: '1.1rem',
    bottom: '0.25rem',
    backgroundColor: 'rgb(225,225,225)',
    color: 'rgb(153,153,153)',
    borderRadius: '50%',
    width: '18px',
    height: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconCheck: {
    right: '.25rem',
    top: '0.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  error: {
    color: '#E53E3E',
    backgroundColor: '#FFDDDD',
  },
  showMaxSize: {
    bottom: '1rem',
    minWidth: '260px',
    borderRadius: '5px',
  },
}))

function SocialMediaSetting(props) {
  const { formatMessage } = useIntl()
  const { name, onChange } = props

  const [field, meta, helpers] = useField(name)
  const isError = !isNil(meta.error) && meta.touched
  const { value } = field

  const { setValue, setTouched } = helpers
  const {
    state: { image, isLoading, isStateError, errorMessage },
    uploadImage,
    selectImage,
    deleteImage,
    onCloseErrorDialog,
  } = useSocialMediaSetting(formatMessage)

  const classes = useStyles()

  const handleUploadFile = (file) => {
    uploadImage(file)
    setTouched(true)
  }

  const haldleDeleteFile = (file) => {
    const deleteResponse = deleteImage(file, value)
    setValue(deleteResponse)
    setTouched(true)
    if (onChange) {
      onChange(deleteResponse)
    }
  }

  const handleSelectFile = async (file) => {
    const images = await selectImage(file, value)
    await setValue(images)
    await setTouched(true)
    if (onChange) {
      onChange(images)
    }
  }
  const onSetValue = () => {
    if (meta.touched) {
      const newValue = [...value, { ...image, isSelected: value.length === 0 }]
      setValue(newValue)
      if (onChange) {
        onChange(newValue)
      }
    }
  }

  useEffect(onSetValue, [image])
  return (
    <div className="relative">
      <MediaContainer
        isLoading={isLoading}
        onUpload={handleUploadFile}
        onSelect={handleSelectFile}
        onDelete={haldleDeleteFile}
        images={value}
        isError={isError}
      />

      <div className={clsx('w-full flex mt-2', isError && 'justify-between')}>
        {isError && (
          <div className="flex space-x-2 py-1">
            <div className="flex my-auto">
              <ErrorIcon classes="w-14" />
            </div>
            <label className="text-red">{meta.error}</label>
          </div>
        )}
      </div>

      {isStateError && !isError && (
        <Box
          className={clsx(
            classes.showMaxSize,
            'absolute shadow-lg b-3 bg-white',
          )}
        >
          <div className="m-20 text-16">
            {errorMessage}
            <div className="flex justify-end my-3 ">
              <Button
                className="text-blue-primary text-16 font-400"
                variant="text"
                onClick={() => onCloseErrorDialog()}
              >
                <FormattedMessage id="action.ok" />
              </Button>
            </div>
          </div>
        </Box>
      )}
    </div>
  )
}

SocialMediaSetting.propTypes = {
  onError: PropTypes.func,
  name: PropTypes.string,
  socialIcon: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.array,
}

export default React.memo(SocialMediaSetting)
